
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1> Aditi Upadhya </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png" alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm aditi-upadhya section-banner-bg-1">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">ADITI UPADHYA <span class="small-sm">16<sup>th</sup> Dec 2018 </span></h2>
                </div>
                <p>
                    Aditi has received intense training in the traditional paramparic style, characterized by the
                    dedicated and close tutelage of her Guru and father, Pt. Dinkar Kaikini, himself a grand and
                    renowned gavaiyya of the Agra Gharana, and her mother, Shashikala Kaikini, respected radio
                    vocalist and current Principal of the Bharatiya Vidya Bhavan’s Music School in Bombay.
                </p>

                <p>
                    It was from the same school that Aditi received her academic degree in music, the Sangeet Visharad,
                    in 1982. A worthy spokeswoman of her father’s powerful but nuanced style of singing, she has also
                    chosen to highlight her lighter musical side, following training under Smt. Shobha Gurtu, known for
                    her unparalleled mastery of Dadra, Thumri and Hori.
                    Aditi frequently gives lecture demonstrations and workshops on Indian classical music to both
                    novices and connoisseurs. Since 1995, she has been regularly called upon to speak for audiences of
                    intellectuals, theoreticians and scientists at Bangalore’s National Institute for Advanced Studies.
                    She is also a devoted Guru to a select group of students. and has also taught Hindustani music at
                    the Mallya Aditi International School in Bangalore.

                </p>
                <p>Artist : Aditi Upadhya </p>
                <p>Date : Sunday – 16<sup>th</sup> Dec 2018</p>
                <p>Time : 6.00 Pm</p>
                <p>Venue : Central Lawns, Chitnavis Centre, Besides Hislop College, Civil Lines, Nagpur</p>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/aditi-upadhya.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Videos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>

                </div>
                <iframe width="100%" height="230" src="https://www.youtube.com/embed/_gLJptTqSms" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery#aditi-upadhya" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/au6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

            </div>



        </div>
    </div>

</section>
